webpackJsonp([187105374086813],{

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookConnect = __webpack_require__(30);
	
	var _LoreHookConnect2 = _interopRequireDefault(_LoreHookConnect);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookConnect2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'first'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'first'
	      ),
	      ' blueprint...'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-connect-blueprints-first-js-279540571d2227eacab1.js